import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { ParkingPass as ParkingPassModel } from 'models/parking-passes';

import { PRINTED_PASS_METHOD } from 'models/validation';


const PrintPass = ({ parkingPass }) => {
  if (!parkingPass.validation.requiredMethods.get(PRINTED_PASS_METHOD)) { return null; }

  return (
    <div className="hidden-print clickable">
      <h5 className="h5-sg text-color-white with-top-margin line-height-extra sm-align-center">
        <FormattedMessage
          id="parking-pass.must-print"
          defaultMessage="PASS MUST BE PRINTED"
        />
      </h5>
      <div className="printing-box row" onClick={() => { window.print(); }}>
        <div className="col-xs-3 hidden-print">
          <span className="iconified iconified-printer float-right" />
        </div>
        <div className="col-xs-9 col-print-12 h5-sg text-color-white vertical-padding-top">
          <FormattedMessage
            id="parking-pass.print-pass"
            defaultMessage="PRINT PARKING PASS"
          />
        </div>
      </div>
    </div>
  );
};

PrintPass.propTypes = {
  parkingPass: PropTypes.instanceOf(ParkingPassModel).isRequired,
};

export default PrintPass;
